import { IsString } from "@pdfking/tfunc"
import { Sleep } from "@pdfking/tfunc"
import { GENERIC_ERROR } from "@pdfking/translations/enum/errors"
import { get_translations } from "@pdfking/workflow/utils/make_translations"
import uuid from "@pdfking/workflow/utils/uuid"
import delete_property from "@pdfking/workflow/vue/3/delete_property"
import set_property from "@pdfking/workflow/vue/3/set_property"
import virtual from "@pdfking/workflow/vue/3/virtual"
import merge from "rfuncs/functions/merge"
import partial from "rfuncs/functions/partial"

import on from "../dom/on"

export default virtual({
  data: () => {
    return { messages: {} }
  },
  methods: {
    add(m, task) {
      const counter = task ? task.counter : null
      const res = IsString(m) ? { content: m, counter } : merge(m, { counter })
      res.id = res.id || uuid()
      set_property(this.messages, res.id, res)

      const remove = partial(this.remove, res.id)

      if (task) {
        task.then(remove)
      } else {
        Sleep(5000).then(remove)
      }
    },
    send_error(error) {
      return get_translations("errors").then(lib =>
        this.add({
          content: lib[error] || lib[GENERIC_ERROR],
          class: "danger",
        })
      )
    },
    remove(id) {
      return delete_property(this.messages, id)
    },
    clear() {
      this.messages = {}
    },
  },
  mounted() {
    on("tracked_error", null, (el, { detail: error }) => this.send_error(error))
  },
})
